/**
 * Creates a hash from a string
 * @param value the value to hash
 * @returns a hash value
 */
export function generateHashFromString(value: string) {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  return hash;
}

/**
 * Picks a stable random item from an array based on a string, usually an id.
 * @param array the items that can be selected
 * @param name a seed that will be used to select the item consistently
 * @returns a random item
 */
export function getRandomItem<T>(array: readonly T[], seed?: string): T {
  if (!seed) {
    return array[Math.floor(Math.random() * array.length)];
  }

  const hash = generateHashFromString(seed);

  const color = Math.abs(hash) % array.length;

  return array[color];
}

export function isArrayItem<T>(array: readonly T[], item: unknown): item is T {
  return array.includes(item as T);
}

export function isArrayItemOrDefault<T>(
  array: readonly T[],
  item?: string,
  defaultValue: T = array[0]
): T {
  return item && isArrayItem(array, item) ? item : defaultValue;
}
